import { render, staticRenderFns } from "./FileDownloadButton.vue?vue&type=template&id=1fceb23e"
import script from "./FileDownloadButton.vue?vue&type=script&lang=js"
export * from "./FileDownloadButton.vue?vue&type=script&lang=js"
import style0 from "./FileDownloadButton.vue?vue&type=style&index=0&id=1fceb23e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports